import { render, staticRenderFns } from "./CenterLoading.vue?vue&type=template&id=bd645964&scoped=true&"
var script = {}
import style0 from "./CenterLoading.vue?vue&type=style&index=0&id=bd645964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd645964",
  null
  
)

export default component.exports